/**
 * Tutorial guidato dell'elenco Fine carrello.
 *
 * Il piu' in alto porta dritto alla pagina della scheda. I tre pallini della riga
 * si raccontano illuminando il pulsante, non la voce dentro il menu: aprire un menu di Vuetify dal tutorial non e'
 * affidabile, perche' il click programmatico e quello su "Avanti" arrivano a
 * `document` a un soffio di distanza e il menu appena aperto legge il secondo come
 * un click fuori. Il pulsante invece c'e' sempre, e il testo dice cosa contiene.
 */
const SCOPE = '[data-tour-scope="cart-end"]';

const at = name => `${SCOPE} [data-tour="${name}"]`;

/** Nessun preparativo: niente da rimettere a posto a fine giro. */
export function stopCartEndTour() {}

export function createCartEndTourSteps() {
	return [
		{
			body: "Questa e' la vetrina che il sito mostra a fine carrello, l'ultima occasione per aggiungere qualcosa prima di pagare. Qui dentro si tiene l'insieme dei prodotti candidati: il sito ne pesca quindici a caso a ogni visita, quindi finche' sono meno di quindici si vedono tutti, oltre quella soglia iniziano a ruotare e nessuno e' garantito.",
			key: 'intro',
			placement: 'bottom',
			target: at('tutorial'),
			title: 'I prodotti di fine carrello',
		},
		{
			body: "Il piu' in alto porta dritto alla pagina Aggiungi prodotto: un campo solo, la ricerca del prodotto. Si cerca per nome o codice, si controlla la variante nel riquadro che compare sotto e si preme Aggiungi nella barra in fondo; Annulla riporta qui.",
			key: 'add',
			placement: 'left',
			target: at('add'),
			title: 'Aggiungere un prodotto',
		},
		{
			body: "La tabella mostra la data in cui il prodotto e' stato messo in vetrina, il suo nome, il codice e le varianti. Una riga e' una variante precisa, non il prodotto intero: mettendo in vetrina una taglia sola, alla cassa comparira' quella.",
			key: 'table',
			placement: 'top',
			target: at('table'),
			title: 'Leggere l’elenco',
		},
		{
			body: "L'ordine delle righe non conta e non si puo' cambiare: il sito sceglie a caso a ogni visita, quindi non c'e' una prima posizione da contendersi. L'unico modo per dare piu' peso a un prodotto e' tenere la vetrina corta.",
			key: 'order',
			placement: 'top',
			target: at('table'),
			title: "L'ordine non conta",
		},
		{
			body: 'I tre pallini a inizio riga hanno una voce sola, Elimina: dopo una conferma toglie il prodotto dalla vetrina di fine carrello. Il prodotto resta a catalogo e in vendita, smette solo di essere proposto qui.',
			key: 'row-menu',
			placement: 'right',
			target: at('row-menu'),
			title: 'Togliere un prodotto',
		},
		{
			body: "L'elenco arriva una pagina per volta dal server: da qui cambi pagina e quante righe vedere. Pagina, righe e ordinamento restano nell'indirizzo: ricaricando o tornando da una scheda li ritrovi.",
			key: 'pagination',
			placement: 'top',
			target: `${SCOPE} .v-data-footer`,
			timeout: 400,
			title: "Sfogliare l'elenco",
		},
	];
}
